import { FormControl, TextField } from "@mui/material";
import { ChangeEvent, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAnswer } from "src/context/AnswerProvider";
import { useQuestions } from "src/context/QuestionsProvider";

const QuestionNumber = () => {
  const { answers, setAnswers } = useAnswer();
  const tag = useQuestions((q) => q.tag);
  const { t } = useTranslation();
  const page = "questions";

  const label = useMemo(() => {
    const type = tag?.split("_")[0].toLowerCase();
    if (type != null) {
      return t(`${page}.placeholder.${type}`);
    }
  }, [t, tag]);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setAnswers([event.target.value]);
    },
    [setAnswers]
  );

  return (
    <FormControl>
      <TextField
        type="number"
        label={label}
        value={answers[0] ?? ""}
        onChange={handleChange}
      />
    </FormControl>
  );
};

export default QuestionNumber;
